// @ts-nocheck — TRACKING_ACTIONS has duplicate keys from aliased enum values
// (e.g. LEGISLATION_PAGE_CONTENTS and PROJECTION_PAGE_CONTENTS both = 'page_contents'),
// plus dynamic string indexing into typed enums in betTracking. Removing the suppression
// requires deduplicating the event taxonomy, which is out of scope.

export enum TRACKING_EVENTS {
  ACCOUNT_MANAGE_SUBSCRIPTION = 'account_go_to_stripe',
  ACCOUNT_RESUBSCRIBE = 'account_resubscribe',
  ACCOUNT_SUBSCRIBE = 'account_subscribe',
  // Bets
  ADD_ACCA_TO_BET_SLIP = 'addAccaToBetslip',

  ADD_TO_BETSLIP = 'add_to_betslip',
  // Grid market selection
  ALL_MARKETS = 'all_markets',
  // All Sports
  ALL_SPORTS_MOBILE = 'allSportsMobile',
  // Insights Page
  ARTICLE_AUTHOR_LINK = 'article_author_link',
  ARTICLE_CATEGORY_TAG = 'article_category_tag',
  ARTICLE_EXTERNAL_HYPERLINK = 'article_external_hyperlink',

  ARTICLE_GENERAL_TAG = 'article_general_tag',

  ARTICLE_HYPERLINK_CLICK = 'article_hyperlink_click',
  ARTICLE_INTERNAL_HYPERLINK = 'article_internal_hyperlink',
  ARTICLE_QUICKLINKS = 'article_quicklinks',
  ARTICLE_SHARE_BUTTON = 'article_share_button',

  ARTICLE_SHARE_BUTTON_ICON = 'article_share_button_icon',
  ARTICLE_SOCIAL_LINK = 'article_social_link',
  AUTHOR_CARD = 'author_card',
  BETSLIP_ICON_CLICKED = 'betslip_icon',
  // Card
  BETTING_GUIDES_CARD = 'betting_guides_card',
  BET_ON_BOOKMAKER_SITE = 'bet_on_bookmaker_site',
  BET_PLACED = 'bet_placed',
  BET_SLIP_CLEAR = 'clear_betslip',
  BET_SLIP_CLOSE = 'close_betslip',
  BET_SLIP_OPEN = 'betSlipOpen',
  BET_SLIP_SIGN_UP = 'betslip_signup',
  BET_SLIP_VIEW = 'betslip_view',
  // Free bets page
  BONUS_FILTER = 'bonus_filter',
  // Navigation
  BOTTOM_NAVIGATION = 'bottom_navigation',

  CHANGE_BOOKIE_SELECTION = 'change_bookie_selection',
  CHANGE_ODDS_FORMAT = 'changeOddsFormat',
  CHANGE_PREMIUM_PLAN = 'change_premium_plan',
  // Offers
  CLAIM_OFFER = 'claimOffer',

  CONTINUE_WITHOUT_PREMIUM = 'continue_without_premium',

  COPY_PROMO_CODE = 'copy_promocode',

  // Date slider
  DATE_SLIDER = 'dateSlider',

  // Email resent
  EMAIL_NOT_RESENT = 'oddscheckerEmailNotResent',

  EMAIL_RESENT = 'oddscheckerEmailResent',

  // Login
  EMAIL_VERIFIED = 'oddscheckerVerifiedAccount',

  // Evergreen content
  EVERGREEN_HP = 'evergreen_hp',

  // Expert Picks
  EXPERT_PICKS = 'expertPicks',

  EXPIRED_EMAIL_NOT_RESENT = 'oddscheckerExpiredEmailNotResent',

  EXPIRED_EMAIL_RESENT = 'oddscheckerExpiredEmailResent',

  FREE_BETS_CUSTOM_FILTER = 'freebets_custom_filter',

  FREE_BETS_CUSTOM_FILTER_ICON = 'freebets_custom_filter_icon',
  FREE_BETS_MORE_INFO = 'freebets_moreinfo_click',
  FREE_BETS_STATE_SELECTOR = 'state_selector',

  FREE_BETS_TERMS = 'freebets_terms',
  HAMBURGER_MENU_CLICK = 'hamburger_menu',
  HAMBURGER_MENU_ITEM = 'hamburger_menu_item',
  HANDICAPPERS_CONTRACT_TAGS_BUTTON = 'handicappers_contract_tags_button',
  HANDICAPPERS_PLUS_NUMBER_BUTTON = 'handicappers_plus_number_button',
  HANDICAPPERS_SPORTS_SLIDER = 'handicappers_sports_slider',

  HANDICAPPERS_STATS = 'handicappers_stats_widget',

  // Desktop header navigation
  HEADER_LEVEL_ONE_DESKTOP_NAV = 'header_level_one_desktop_nav',
  HEADER_LEVEL_THREE_DESKTOP_NAV = 'header_level_three_desktop_nav',
  HEADER_LEVEL_TWO_DESKTOP_NAV = 'header_level_two_desktop_nav',

  INSIGHTS_ARTICLE_PAGE = 'insights_article_page',

  INSIGHTS_CARD = 'insights_card',
  LATEST_ARTICLE_CLICK = 'latest_article_click',
  LEGISLATION_BACK_TO_TOP = 'legislation_backtotop',
  LEGISLATION_PAGE_CONTENTS = 'page_contents',

  // LEGISLATION
  LEGISLATION_STATE_CARDS = 'legislation_state_cards',
  LEGISLATION_STATE_LIST = 'legislation_state_list',
  LEGISLATION_STATE_MAP = 'legislation_state_map',
  LEGISLATION_VIEW_MORE = 'legislation_view_more',
  LOGIN = 'oddscheckerLogin',
  LOGIN_FAIL = 'oddscheckerLoginFail',
  LOGIN_NAVIGATION = 'login_navigation',
  // Logout
  LOG_OUT = 'oddscheckerLogOut',
  MARKET_SECONDARY_TIER = 'market_secondary_tier',
  MARKET_THIRD_TIER = 'market_third_tier',
  // Mobile Download
  MOBILE_DOWNLOAD = 'mobileDownload',
  MYOC_ACCOUNT_VERIFIED = 'myoc_account_verified',
  MYOC_FAQ_ICON = 'myoc_faq_icon',

  MYOC_FAQ_QUESTIONS = 'myoc_faq_questions',
  MY_ACCOUNT_ICON_DROPDOWN_CLICK = 'my_account_icon_dropdown_click',
  // Next up games odds click
  NEXT_UP_GAMES = 'next_up_games',
  // Next up games tab
  NEXT_UP_GAMES_TAB = 'nextup_games_tab',
  ODDS_FORMAT_DROPDOWN_CLICK = 'odds_format_dropdown_click',
  OFFER_DETAILS = 'offerDetails',

  // Parlay calculator
  PARLAY_CALCULATE = 'parlay_calculator',
  PICKS_ARTICLE_CREATE_ACCOUNT = 'picksarticle_createaccount',
  PICKS_CARD = 'picks_card',
  PICKS_HUB_CREATE_ACCOUNT = 'pickshub_createaccount',
  // Next up games odds click
  POPULAR_BETS_CLICK = 'popularBets_click',

  // PREMIUM
  PREMIUM_UPGRADE = 'premium_upgrade',
  // Hero splash click
  PRIMARY_HERO_CLICK = 'primary_hero_click',
  PROJECTION_LOCK_CLICK = 'projection_lock_click',
  PROJECTION_MATCHUP_ODDS = 'projection_matchup_odds',
  // PROJECTION
  PROJECTION_PAGE_CONTENTS = 'page_contents',
  PROJECTION_TEAM_NAMES = 'projection_team_names',

  PROJECTION_VIEW_MORE = 'projection_view_more',
  PROMO_CONTENTS_ARROW = 'free_bets_contents_arrow',
  // Promo Pages
  PROMO_MAIN_OFFER_TERMS = 'free_bets_terms_click',
  PROMO_OFFER_CLAIM = 'claim_offer',
  PROMO_OFFER_TERMS = 'freebets_terms',
  PROMO_PAGE_CONTENTS = 'free_bets_page_contents',
  // Promos page
  PROMO_QUICKLINKS = 'promo_quicklinks',
  PROMO_VISIT_SITE = 'free_bets_vist_site',
  REMOVE_BET = 'remove_bet',
  SCROLL_TO_TOP_BUTTON = 'article_scroll_to_top',
  SELECT_BOOKIE = 'select_bookie',
  SELECT_MARKET = 'select_market',
  SELECT_SUBSCRIPTION_OPTION = 'select_subscription_option',
  SIGN_ME_UP_NAV = 'signmeup_nav',
  // Signup
  SIGN_UP = 'oddscheckerSignup',
  SIGN_UP_CLICKED = 'signup_link_clicked',
  SIGN_UP_CONTAINER = 'signupContainer',
  SIGN_UP_FAIL = 'oddscheckerSignupFail',
  SOCIAL_LOGIN = 'oddscheckerSocialLogin',
  SOCIAL_LOGIN_FAIL = 'oddscheckerSocialLoginFail',
  SUBSCRIBE_TO_PREMIUM_CONFIRMATION = 'sub_confirmation',
  SUBSCRIBE_TO_PREMIUM_CTA = 'subscribe_to_premium_cta',
  SUBSCRIBE_TO_PREMIUM_FREE_TRIAL = 'subscribe_free_trial',

  SUBSCRIPTION_CONTACT_US = 'subscription_contact_us',
  SUBSCRIPTION_FAIL = 'sub_confirmation_fail',
  SUBSCRIPTION_SUCCESSFUL = 'sub_confirmation_success',
  TERMS_CLICK = 'offer_terms_click',
  // Tips
  TIPS_ARTICLE_VIEW = 'tipsArticleView',
  // Handicappers
  VIEW_ALL_HANDICAPPERS_LINK = 'handicappers_view_all',

  // Virtual Page View
  VIRTUAL_PAGE_VIEW = 'virtualPageView',
}

export enum TRACKING_CATEGORIES {
  ALL_MARKETS = 'All Markets',
  ALL_SPORTS_MOBILE = 'All Sports mobile',
  ARTICLE = 'Article',
  ARTICLE_HYPERLINK_CLICK = 'Article Hyperlink',
  BETSLIP = 'Betslip',
  BETTING = 'Betting',
  BETTING_GUIDES = 'Betting guides',
  EVERGREEN = 'Evergreen Content',
  FREE_BETS = 'Free Bets Page',
  HANDICAPPERS = 'Handicappers',
  HOMEPAGE = 'Homepage',
  INSIGHTS = 'Insights',
  LEGISLATION_PAGES = 'Legislation Pages',
  MARKETS = 'Markets',
  MOBILE_DOWNLOAD = 'Mobile Download',
  NAVIGATION = 'Navigation',
  ODDSCHECKER_ACCOUNT = 'Oddschecker Account',
  ODDS_FORMAT = 'Odds Format',
  OFFERS = 'Offers',
  PAGE_VIEW = 'Page View',
  PARLAY_CALCULATOR = 'Parlay calculator',
  PICKS = 'Picks',
  PREMIUM = 'OC Premium',
  PREMIUM_ACCOUNT = 'OC Premium account',
  PREMIUM_SIGNUP = 'OC Premium sign up',
  PRIMARY_HERO_CLICK = 'primary_hero_click',
  PROJECTION = 'Projection',
  PROMOS = 'Promos Page',
  RACING_PAGES = 'Racing Pages',
  TAKEOVER = 'Takeover',
  TIPS = 'Tips',
}

export const TRACKING_ACTIONS = {
  [TRACKING_EVENTS.EMAIL_RESENT]: 'Email resent',
  [TRACKING_EVENTS.EMAIL_NOT_RESENT]: 'Verification e-mail has not been resent',
  [TRACKING_EVENTS.EXPIRED_EMAIL_RESENT]: 'Expired e-mail resent',
  [TRACKING_EVENTS.EXPIRED_EMAIL_NOT_RESENT]: 'New link from expired e-mail has not been sent',

  [TRACKING_EVENTS.EMAIL_VERIFIED]: 'account_verified',
  [TRACKING_EVENTS.LOGIN_NAVIGATION]: 'oc_login_clicked',
  [TRACKING_EVENTS.LOGIN]: 'Log In',
  [TRACKING_EVENTS.LOGIN_FAIL]: 'Log In Fail',
  [TRACKING_EVENTS.SOCIAL_LOGIN]: 'Social Log In',
  [TRACKING_EVENTS.SOCIAL_LOGIN_FAIL]: 'Social Log In Fail',

  [TRACKING_EVENTS.LOG_OUT]: 'Log Out',

  [TRACKING_EVENTS.SIGN_UP_CLICKED]: 'oc_signup_clicked',
  [TRACKING_EVENTS.SIGN_UP]: 'Sign Up',
  [TRACKING_EVENTS.SIGN_UP_FAIL]: 'Sign Up Fail',
  [TRACKING_EVENTS.SIGN_UP_CONTAINER]: 'oc_signup_container',

  [TRACKING_EVENTS.ADD_ACCA_TO_BET_SLIP]: 'Add to Betslip',
  [TRACKING_EVENTS.ADD_TO_BETSLIP]: 'Add to betslip',
  [TRACKING_EVENTS.BET_ON_BOOKMAKER_SITE]: 'Bet on bookmaker site click',
  [TRACKING_EVENTS.BET_PLACED]: 'betslip_clickouts',
  [TRACKING_EVENTS.BET_SLIP_CLEAR]: 'Clear Betslip',
  [TRACKING_EVENTS.BET_SLIP_CLOSE]: 'Close Betslip',
  [TRACKING_EVENTS.BET_SLIP_OPEN]: 'Open Betslip',
  [TRACKING_EVENTS.BET_SLIP_SIGN_UP]: 'bookie sign up',
  [TRACKING_EVENTS.BET_SLIP_VIEW]: 'betslip_view',
  [TRACKING_EVENTS.BETSLIP_ICON_CLICKED]: 'Betslip Icon Clicked',
  [TRACKING_EVENTS.CHANGE_BOOKIE_SELECTION]: 'Change bookie selection',
  [TRACKING_EVENTS.CHANGE_ODDS_FORMAT]: 'change_odds_format',
  [TRACKING_EVENTS.REMOVE_BET]: 'Remove Bet',
  [TRACKING_EVENTS.SELECT_BOOKIE]: 'Select Bookie',

  [TRACKING_EVENTS.CLAIM_OFFER]: '_customers_offer',
  [TRACKING_EVENTS.COPY_PROMO_CODE]: 'Promo code copied',
  [TRACKING_EVENTS.OFFER_DETAILS]: 'Offer Details | ',
  [TRACKING_EVENTS.TERMS_CLICK]: 'Offer component',

  [TRACKING_EVENTS.TIPS_ARTICLE_VIEW]: 'tips_article_view',

  [TRACKING_EVENTS.ALL_SPORTS_MOBILE]: 'All Sports mobile button pressed',

  [TRACKING_EVENTS.MOBILE_DOWNLOAD]: 'Mobile Download',

  [TRACKING_EVENTS.DATE_SLIDER]: 'date_slider',

  [TRACKING_EVENTS.VIRTUAL_PAGE_VIEW]: 'page_view',

  [TRACKING_EVENTS.PRIMARY_HERO_CLICK]: 'Primary hero click',

  [TRACKING_EVENTS.NEXT_UP_GAMES]: 'Nextup games odds click',

  [TRACKING_EVENTS.POPULAR_BETS_CLICK]: 'Popular bets odds click',
  [TRACKING_EVENTS.EXPERT_PICKS]: 'Expert Picks odds click',

  [TRACKING_EVENTS.NEXT_UP_GAMES_TAB]: 'NextUp Games Tab',

  [TRACKING_EVENTS.BONUS_FILTER]: 'Bonus filter',
  [TRACKING_EVENTS.BOTTOM_NAVIGATION]: 'bottom_navigation',
  [TRACKING_EVENTS.FREE_BETS_CUSTOM_FILTER_ICON]: 'Custom filter',
  [TRACKING_EVENTS.FREE_BETS_CUSTOM_FILTER]: 'Custom filter',
  [TRACKING_EVENTS.FREE_BETS_MORE_INFO]: 'More info mobile',
  [TRACKING_EVENTS.FREE_BETS_STATE_SELECTOR]: 'State dropdown',
  [TRACKING_EVENTS.FREE_BETS_TERMS]: 'T&C Click',
  [TRACKING_EVENTS.HAMBURGER_MENU_CLICK]: 'hamburger_menu',
  [TRACKING_EVENTS.HAMBURGER_MENU_ITEM]: 'hamburger_menu',

  [TRACKING_EVENTS.BETTING_GUIDES_CARD]: 'Betting guides card',
  [TRACKING_EVENTS.INSIGHTS_ARTICLE_PAGE]: 'Insights article page',
  [TRACKING_EVENTS.INSIGHTS_CARD]: 'Insights card',
  [TRACKING_EVENTS.PARLAY_CALCULATE]: 'Calculate',

  [TRACKING_EVENTS.ARTICLE_CATEGORY_TAG]: 'Article category link',
  [TRACKING_EVENTS.ARTICLE_GENERAL_TAG]: 'Article general tag (no link)',
  [TRACKING_EVENTS.ARTICLE_QUICKLINKS]: 'Article quick links',
  [TRACKING_EVENTS.PROMO_QUICKLINKS]: 'Promo quick links',
  [TRACKING_EVENTS.ARTICLE_SOCIAL_LINK]: 'Article social button',
  [TRACKING_EVENTS.AUTHOR_CARD]: 'Author view profile CTA',
  [TRACKING_EVENTS.LATEST_ARTICLE_CLICK]: 'latest article component',
  [TRACKING_EVENTS.SCROLL_TO_TOP_BUTTON]: 'Scroll to top button',

  [TRACKING_EVENTS.ARTICLE_EXTERNAL_HYPERLINK]: 'External Hyperlink',
  [TRACKING_EVENTS.ARTICLE_INTERNAL_HYPERLINK]: 'Internal Hyperlink',
  [TRACKING_EVENTS.ARTICLE_SHARE_BUTTON_ICON]: 'Article share button icon',
  [TRACKING_EVENTS.ARTICLE_SHARE_BUTTON]: 'Article share button',

  [TRACKING_EVENTS.ALL_MARKETS]: 'drop down click',
  [TRACKING_EVENTS.ARTICLE_AUTHOR_LINK]: 'Article author link',
  [TRACKING_EVENTS.MARKET_THIRD_TIER]: 'All Markets',

  [TRACKING_EVENTS.VIEW_ALL_HANDICAPPERS_LINK]: 'Handicappers View All',
  [TRACKING_EVENTS.HANDICAPPERS_STATS]: 'Handicappers Stats Widget',
  [TRACKING_EVENTS.HANDICAPPERS_PLUS_NUMBER_BUTTON]: 'Handicappers Plus Number Button',
  [TRACKING_EVENTS.HANDICAPPERS_CONTRACT_TAGS_BUTTON]: 'Handicappers Contract Tags Button',
  [TRACKING_EVENTS.HANDICAPPERS_SPORTS_SLIDER]: 'Handicappers Sports Slider',
  [TRACKING_EVENTS.PROMO_MAIN_OFFER_TERMS]: 'T&C click',
  [TRACKING_EVENTS.PROMO_VISIT_SITE]: 'new_customers_offer',
  [TRACKING_EVENTS.PROMO_CONTENTS_ARROW]: 'page_contents_arrow',
  [TRACKING_EVENTS.PROMO_PAGE_CONTENTS]: 'page_contents',
  [TRACKING_EVENTS.PROMO_OFFER_TERMS]: 'T&C Click',
  [TRACKING_EVENTS.PROMO_OFFER_CLAIM]: 'new_customers_offer',

  [TRACKING_EVENTS.PREMIUM_UPGRADE]: 'content filtering',
  [TRACKING_EVENTS.SIGN_ME_UP_NAV]: 'Top_Navigation',
  [TRACKING_EVENTS.PICKS_HUB_CREATE_ACCOUNT]: 'Picks hub',
  [TRACKING_EVENTS.SELECT_SUBSCRIPTION_OPTION]: 'select subscription option',
  [TRACKING_EVENTS.SUBSCRIBE_TO_PREMIUM_CTA]: 'subscribe to premium',
  [TRACKING_EVENTS.SUBSCRIBE_TO_PREMIUM_FREE_TRIAL]: 'Start 7 Day Free Trial',
  [TRACKING_EVENTS.SUBSCRIPTION_CONTACT_US]: 'Contact Us',
  [TRACKING_EVENTS.CONTINUE_WITHOUT_PREMIUM]: 'winning is not for me',
  [TRACKING_EVENTS.ACCOUNT_RESUBSCRIBE]: 'Manage Subscription',
  [TRACKING_EVENTS.ACCOUNT_SUBSCRIBE]: 'Manage Subscription',
  [TRACKING_EVENTS.ACCOUNT_MANAGE_SUBSCRIPTION]: 'Manage Subscription',
  [TRACKING_EVENTS.MYOC_FAQ_ICON]: 'FAQ',
  [TRACKING_EVENTS.MYOC_FAQ_QUESTIONS]: 'FAQ',
  [TRACKING_EVENTS.CHANGE_PREMIUM_PLAN]: 'content filtering',
  [TRACKING_EVENTS.SUBSCRIPTION_SUCCESSFUL]: 'Successful Subscription',
  [TRACKING_EVENTS.SUBSCRIPTION_FAIL]: 'Subscription Fail',
  [TRACKING_EVENTS.MYOC_ACCOUNT_VERIFIED]: 'Account verified',
  [TRACKING_EVENTS.PICKS_ARTICLE_CREATE_ACCOUNT]: 'Article',
  [TRACKING_EVENTS.PROJECTION_MATCHUP_ODDS]: 'View Matchup Odds',

  [TRACKING_EVENTS.LEGISLATION_STATE_CARDS]: 'View State Page',
  [TRACKING_EVENTS.LEGISLATION_VIEW_MORE]: 'View More States',
  [TRACKING_EVENTS.LEGISLATION_BACK_TO_TOP]: 'Back to Top',
  [TRACKING_EVENTS.LEGISLATION_PAGE_CONTENTS]: 'Page Contents',
  [TRACKING_EVENTS.PROJECTION_PAGE_CONTENTS]: 'Page Contents',
};

export const TRACKING_LABELS = {
  [TRACKING_EVENTS.SIGN_UP_CONTAINER]: 'Signup clicked',
  [TRACKING_EVENTS.HAMBURGER_MENU_CLICK]: 'hamburger_icon_clicked',
  [TRACKING_EVENTS.FREE_BETS_CUSTOM_FILTER]: 'Filter interaction',
  [TRACKING_EVENTS.FREE_BETS_CUSTOM_FILTER_ICON]: 'icon click',
  [TRACKING_EVENTS.CLAIM_OFFER]: 'article_offer_component',
  [TRACKING_EVENTS.TERMS_CLICK]: 'T&C click',
  [TRACKING_EVENTS.PROMO_VISIT_SITE]: 'visit_site',
  [TRACKING_EVENTS.PROMO_OFFER_TERMS]: 'freebets_review_promo_carousel',
  [TRACKING_EVENTS.PROMO_OFFER_CLAIM]: 'freebets_review_promo_carousel',
  [TRACKING_EVENTS.PROJECTION_LOCK_CLICK]: 'Projection lock click',
  [TRACKING_EVENTS.PROJECTION_VIEW_MORE]: 'View More',
  [TRACKING_EVENTS.LEGISLATION_PAGE_CONTENTS]: 'Page Contents Button',
  [TRACKING_EVENTS.PROJECTION_PAGE_CONTENTS]: 'Page Contents Button',
};

export const DESKTOP_HEADER_TRACKING_EVENTS = {
  account: TRACKING_EVENTS.MY_ACCOUNT_ICON_DROPDOWN_CLICK,
  oddsFormat: TRACKING_EVENTS.ODDS_FORMAT_DROPDOWN_CLICK,
  primary: TRACKING_EVENTS.HEADER_LEVEL_ONE_DESKTOP_NAV,
  secondary: TRACKING_EVENTS.HEADER_LEVEL_TWO_DESKTOP_NAV,
  tertiary: TRACKING_EVENTS.HEADER_LEVEL_THREE_DESKTOP_NAV,
} as const;

export enum OfferType {
  BONUS_BETS = 'bonus_bets',
  BONUS_BETS_BOOKIE_LOGO = 'bonus_bets_bookielogo',
  BONUS_BETS_PPC = 'bonus_bets_ppc',
  BONUS_BETS_RECOMMENDED_OFFER = 'bonus_bets_recommended_offer',
  BONUS_BETS_RECOMMENDED_OFFER_BOOKIE_LOGO = 'bonus_bets_recommended_offer_bookielogo',
  BOOKIE_OFFER_ARTICLE = 'bookie_offer_article',
  BOOKIE_OFFER_MULTI = 'bookie_offer_multi_',
  BOOKIE_OFFER_MULTI_CARDPAGE = 'bookie_offer_multi_cardpage',
  BOOKIE_OFFER_MULTI_GRIDPAGE = 'bookie_offer_multi_gridpage',
  BOOKIE_OFFER_MULTI_HOMEPAGE = 'bookie_offer_multi_homepage',
  BOOKIE_OFFER_REST = 'bookie_offer_rest',
  BOOKIE_REVIEW_OFFER = 'bookie_review_offer',
  BOOKIE_REVIEW_PAGE = 'BOOKIE_REVIEW_PAGE',
  BOTTOM_BANNER = 'bottom_banner',
  CAROUSEL_OFFER_HOMEPAGE = 'carousel_offer_homepage',
  FREE_BETS_SINGLE_OFFER = 'free_bets_single_offer',
  GRID_BOOKIE_BONUS = 'grid_bookie_bonus',
  GRID_BOOKIE_JOIN = 'grid_bookie_join',
  GRID_BOOKIE_LOGO_TOP = 'grid_bookie_logo_top',
  GRID_BOOKIE_SPECIAL_OFFER = 'grid_bookie_special_offer',
  HERO_SPLASH_OFFER = 'hero_splash_offer',
  PROMO_PAGE_BETS = 'promo_page_bets',
  PROMO_PAGE_SUB_TOP = 'promo_page_sub_top',
  RACING_PAGE_OFFER = 'racing_page_offer',
  REVIEW_PAGE_BETS = 'review_page_bets',
  REVIEW_PROMO_SUBBOTTOM = 'review_promo_subbottom',
  REVIEW_PROMO_SUBTOP = 'review_promo_subtop',
  TIPS_ARTICLE_DESCRIPTION_OFFER = 'tips_article_description_offer',
  TOP_BETTING_SITES = 'top_betting_sites',
  TOP_BETTING_SITES_HOMEPAGE = 'top_betting_sites_homepage',
}

export enum OfferName {
  BONUS_BETS = 'Bonus Bets',
  BOOKIE_REVIEW = 'Bookie Review',
}

export enum CustomerType {
  NEW = 'new',
}

export enum BetTypes {
  EXPERT_PICKS = 'EXPERT_PICKS',
  NEXT_UP_GAMES = 'NEXT_UP_GAMES',
  POPULAR_BETS_CLICK = 'POPULAR_BETS_CLICK',
}

export enum CardSubComponents {
  BLANK_SPACE = 'Blank Space',
  CARD_IMAGE = 'Card Image',
  CARD_SUMMARY = 'Card Summary',
  CARD_TITLE = 'Card Title',
  ESTIMATED_READ_TIME = 'Estimated Read Time',
  READ_FULL_ARTICLE = 'Read Full Article CTA',
}

interface IOffer {
  bookie?: string;
  customer?: string;
  index?: number;
  name?: string;
  type?: string;
}

export interface ITrackingProps {
  accumulator?: string;
  author?: string;
  bet?: object;
  betName?: string;
  betOdds?: string;
  betStake?: string;
  bookieCode?: string;
  customer_id?: string;
  event?: string;
  eventAction?: string;
  eventCategory?: string;
  eventLabel?: string;
  event_name?: string;
  marketName?: string;
  newOddsFormat?: string;
  offer?: IOffer;
  page?: {
    title: string;
    url: string;
  };
  payout?: string;
  product?: string;
  product_description?: string;
  selection?: string;
  subeventName?: string;
  tipname?: string;
  tipscategory?: string;
  user?: {
    email?: string;
    optin?: 'yes' | 'no';
    userId?: string;
    userState?: string;
  };
  userId?: string;
  wager?: string;
}

export interface ITrackingActions {
  addObjectToDataLayer: (obj: Record<string, unknown>) => void;
  betTracking: ({ bookieCode, category, label }: { bookieCode: string; category?: string; label: string }) => void;
  eventTracking: (obj: ITrackingProps) => void;
}
